import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { Box, Chip, IconButton, Typography } from '@mui/material';

interface CollapsedColumnStripProps {
  patientName: string;
  patientIdShort: string;
  selectedCount: number;
  totalCount: number;
  patientColor: string;
  patternStyle: { backgroundImage: string };
  onExpand: () => void;
}

export function CollapsedColumnStrip({
  patientName,
  patientIdShort,
  selectedCount,
  totalCount,
  patientColor,
  patternStyle,
  onExpand,
}: CollapsedColumnStripProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1.5,
        py: 1,
        borderRadius: 2,
        border: 1,
        borderColor: 'divider',
        borderBottom: 2,
        borderBottomColor: patientColor,
        backgroundColor: `${patientColor}08`,
        ...patternStyle,
        cursor: 'pointer',
        flexShrink: 0,
        '&:hover': { backgroundColor: `${patientColor}12` },
      }}
      onClick={onExpand}
      role="button"
      aria-label={`Expand ${patientName} column`}
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onExpand();
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flex: 1,
          minWidth: 0,
          backgroundColor: 'rgba(255,255,255,0.85)',
          borderRadius: 1,
          px: 1,
          py: 0.5,
        }}
      >
        <IconButton size="small" tabIndex={-1} aria-hidden>
          <ChevronRightIcon fontSize="small" />
        </IconButton>

        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" fontWeight={600} noWrap>
            {patientName}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap display="block" sx={{ fontFamily: 'monospace', fontSize: '0.6rem' }}>
            {patientIdShort}
          </Typography>
        </Box>

        <Chip
          label={`${selectedCount}/${totalCount}`}
          size="small"
          sx={{ height: 20, fontSize: '0.65rem', ml: 'auto', flexShrink: 0 }}
        />
      </Box>
    </Box>
  );
}
